<template>
  <v-container id="soslogs" fluid tag="section">
    <div class="text-right">
      <v-btn color="cyan" @click="showFilter = !showFilter" small>
        <v-icon>mdi-filter</v-icon>
      </v-btn>
    </div>

    <v-row justify="center" v-if="showFilter">
      <v-col cols="12" md="12">
        <base-material-card
          color="cyan"
          icon="mdi-filter"
          class="px-3 py-1 small-icon"
          v-if="showFilter"
        >
          <div class="filter-close">
            <v-btn color="black" class="mr-0" fab small text @click="showFilter = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </div>
          <v-row>
            <v-col cols="12" sm="3" md="2" lg="2">
              <z-date-picker
                :label="$i18n.t('From Date')"
                class="purple-input"
                v-model="filter.from_date"
              />
            </v-col>
            <v-col cols="12" sm="3" md="2" lg="2">
              <z-date-picker
                :label="$i18n.t('Till Date')"
                class="purple-input"
                v-model="filter.to_date"
              />
            </v-col>

            <v-col cols="12" sm="12" md="3" lg="2">
              <v-select
                :label="$i18n.t('Status')"
                :items="statusList"
                class="purple-input"
                v-model="filter.status"
                clearable
              />
            </v-col>

            <v-col cols="12" sm="12" md="3" lg="2" class="text-right">
              <v-btn
                color="info"
                class="mr-3"
                fab
                small
                dark
                @click="download()"
                :loading="loading"
              >
                <v-icon small>mdi-printer</v-icon>
              </v-btn>
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-btn
                    class="mr-0"
                    color="grey darken"
                    fab
                    text
                    small
                    @click="clear(1)"
                    style="margin-right: 10px !important"
                    v-on="on"
                  >
                    <v-icon>mdi-cached</v-icon>
                  </v-btn>
                </template>
                <span>{{ $i18n.t("Clear Filter") }}</span>
              </v-tooltip>
              <v-btn
                color="success"
                class="mr-3"
                fab
                small
                dark
                @click="search()"
                :loading="loading"
              >
                <v-icon>mdi-magnify</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </base-material-card>
      </v-col>
    </v-row>

    <v-btn
      v-if="grid != undefined && !grid.records"
      class="text-center secondary--text pa-10"
      text
      color="primary"
      style="width: 100%"
      :loading="loading"
    >{{ $i18n.t("No records available") }}</v-btn>

    <base-material-card
      icon="mdi-account-multiple"
      :title="$i18n.t('SOS Logs')"
      class="px-5 py-3 small-icon"
      v-if="grid.records"
      color="primary"
    >
      <z-grid-record :grid="grid" />

      <v-simple-table dense>
        <template v-slot:default>
          <thead class="thead">
            <tr>
              <th class="text-left">{{ $i18n.t("User Detail") }}</th>
              <th class="text-left">{{ $i18n.t("Address") }}</th>
              <th class="text-left">{{ $i18n.t("At") }}</th>
              <th class="text-left">{{ $i18n.t("Status") }}</th>
              <th class="text-left">{{ $i18n.t("Action") }}</th>
            </tr>
          </thead>
          <access-row v-for="trip in grid.rows" :key="trip._id" :value="trip" @reload="reload" />
        </template>
      </v-simple-table>

      <v-container>
        <v-pagination
          v-model="grid.page"
          class="my-4"
          :length="grid.total"
          total-visible="10"
          @input="showPage"
        ></v-pagination>
      </v-container>
    </base-material-card>
  </v-container>
</template>

<script>
import { Vue, Component } from "vue-property-decorator";
import { doGet, doPost, doPostForm } from "@/store/common/module/apis";
import common from "@/store/common/module/common";
import AccessRow from "@/views/access/AccessRow.vue";

@Component({
  name: "AccessLogs",
  components: { AccessRow },
})
export default class AccessLogs extends Vue {
  grid = { page: 0, rows: [] };
  url = "/api/accesslog/grid?sord=desc&sidx=_id&";
  showFilter = false;
  filterUrl = "";
  on = null;
  page = 1;
  rows = 50;
  statusList = [
    { text: "Open", value: "0" },
    { text: "Resolved", value: "1" },
    { text: "Critical", value: "2" },
  ];

  filter = {
    from_date: null,
    to_date: null,
    status: null,
  };

  getFilterReq() {
    let filterUrl = "";
    if (this.filter.from_date)
      filterUrl += "&from_date=" + this.filter.from_date;
    if (this.filter.to_date) filterUrl += "&to_date=" + this.filter.to_date;
    if (this.filter.status) filterUrl += "&status=" + this.filter.status;

    return filterUrl;
  }

  async search() {
    this.filterUrl = this.getFilterReq();

    common.setLoading(true);
    await this.showPage(1);
  }

  async download() {
    await doGet(
      "/api/sos/report/download?sord=desc&sidx=_id&" + this.filterUrl
    );
  }

  async showPage(page) {
    common.setLoading(true);
    this.page = page;
    try {
      const grid = await doGet(
        this.url + "rows=" + this.rows + "&page=" + page + this.filterUrl
      );
      if (grid.rows && grid.rows.length > 0) {
        for (let i = 0; i < grid.rows.length; i++) {
          grid.rows[i].selected = false;
        }
      }
      this.grid = grid;
    } catch (e) {
      common.setError(e.message);
    }
    common.setLoading(false);
  }

  async clear() {
    this.filter = {};
    this.page = 1;
    this.search();
  }

  async refresh(__i) {
    if (__i == 1) {
      this.search();
    }
  }

  async reload() {
    this.showPage(this.page);
  }

  get loading() {
    return common.loading;
  }

  get gridHeight() {
    return this.windowHeight > 500 ? this.windowHeight - 150 : 300;
  }

  get itemHeight() {
    return this.windowWidth > 960 ? 75 : 240;
  }

  async mounted() {
    this.search();
  }
}
</script>

<style scoped>
.filter-close {
  position: absolute;
  right: 5px;
  top: 5px;
}
.dialog {
  position: fixed;
  top: 100px;
  width: 60%;
  z-index: 10;
  margin-left: 15%;
}
.sticky-bottom {
  position: sticky;
  bottom: 0;
  background-color: white;
  border-top: 1px solid #dfdfdf;
}
.sticky-top {
  position: sticky;
  top: 0;
  z-index: 2;
}

.v-card__subtitle,
.v-card__text {
  font-size: 14px;
}

.v-expansion-panel-header--active {
  background-color: aliceblue;
  min-height: 50px !important;
}

tbody:nth-child(even) {
  background: #fafafa;
}
.thead tr th {
  padding: 0 2px !important;
}
</style>
